import { ErrorAssembler } from '@src/orders/PermitFormSections/ErrorAssembler';
import { PermitFormErrorsContext } from '@src/orders/PermitFormSections/PermitFormErrorsContext';
import type { ReactNode } from 'react';
import { useFormContext } from 'react-hook-form';

export const PermitFormErrorsContextProvider = ({
  children,
}: {
  children: ReactNode;
}) => {
  const {
    formState: { errors },
  } = useFormContext();

  const formErrorKeys = ErrorAssembler.toErrorKeys(errors);

  return (
    <PermitFormErrorsContext.Provider
      value={{
        formErrorKeys,
      }}
    >
      {children}
    </PermitFormErrorsContext.Provider>
  );
};
